'use strict';

const MS_BEFORE_REQUEST = 200;
const REGEX_NAME = /[^a-zA-ZñÑ\s]/;
const REGEX_NUMBER = /^[0-9]+$/;

// This IDs must match with those on the Business Manager
const PRODUCT_OPTION_ID_PERSONALIZATION_NAME = 'namePersonalization';
const PRODUCT_OPTION_ID_PERSONALIZATION_NUMBER = 'numberPersonalization';

var personalization = {};

var arrayOptionNumberPersonalization = {};
var arrayOptionNamePersonalization = {};

let personalizationNumberHasError = false;
let personalizationNameHasError = false;

var hideOptionsArray = $('#hideOptions').val();

var nameModal;
var numberModal;
var costNameModal;
var costNumberModal;
var totalCostModal;
var nameSide;
var numberSide;
var selectedColor;
var selectedColorHex;
var selectedFont;

var pageUUID;
var productID;
var productIDMaster;
var dynamicPersonalization;

const removeAllWhiteSpaces = (str) => str.replace(/\s/g, '');

// Generate UUID for page
function generateUniqueId() {
    // Generate a random UUID (not cryptographically secure)
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

var oldPageUUID = localStorage.getItem('pageUUID') || '';

// Generate a new UUID on page load
pageUUID = $('#pageUUID').val();

// Store the new UUID as the old UUID in local storage, or set it as the current UUID if there's no old UUID
if (!oldPageUUID) {
    oldPageUUID = pageUUID;
    localStorage.setItem('pageUUID', pageUUID);
}

function resetlocalStoragePersonalization() {
    var itemToDelete = (pageUUID + '_' + productID + '_personalizationsData');
    if (localStorage.getItem(itemToDelete)) {
        localStorage.removeItem(itemToDelete);
    } else {
        for (var i = 0; i < localStorage.length; i++) {
            var key = localStorage.key(i);
            if (key.includes(oldPageUUID + '_' + productIDMaster)) {
                localStorage.removeItem(key);
            }
        }
    }
}

localStorage.setItem('pageUUID', pageUUID);

$(document).ready(function () {
    resetlocalStoragePersonalization();
});

function createPersonalizationUniqueID() {
    dynamicPersonalization = pageUUID + '_' + productID + '_personalizationsData';
}

function getEventPersonalizationsModal() {
    var lengthFormName = $('#personalization-form-name').val() ? $('#personalization-form-name').val().length : 0;
    var lengthFormNumber = $('#personalization-form-number').val() ? $('#personalization-form-number').val().length : 0;
    if ((lengthFormName + lengthFormNumber) === 0) {
        $('.summaryContainer-PDP').addClass('d-none');
    }
}

function getValuePersonalizationsModal() {
    nameModal = $('#personalization-form-name').val() ? $('#personalization-form-name').val() : '';
    numberModal = $('#personalization-form-number').val() ? $('#personalization-form-number').val() : '';
    costNameModal = $('#name-price').text().replace(/\D/g, '') ? $('#name-price').text().replace(/\D/g, '') : '0';
    costNumberModal = $('#number-price').text().replace(/\D/g, '') ? $('#number-price').text().replace(/\D/g, '') : '0';
    totalCostModal = parseInt(costNameModal) + parseInt(costNumberModal);
    nameSide = $('input[name="nameSidePersonalization"]:checked') ? $('input[name="nameSidePersonalization"]:checked').val() : '';
    numberSide = $('input[name="numberSidePersonalization"]:checked') ? $('input[name="numberSidePersonalization"]:checked').val() : '';
    selectedColor = $('.selected-shadow').attr('data-color');
    selectedFont = $('.font-selector option:selected').val();
}
/**
 * TODO: Move this function to a helper folder
 * Source: https://developer.mozilla.org/es/docs/Web/JavaScript/Referencia/Objetos_globales/NumberFormat
 * Formats a number value to a valid string representing money
 * @param {Number} value - money amount
 * @param {String} locale - locale of the conversion (example 'es-AR')
 * @param {String} currency - ISO Code for the currency to convert (example 'ARS')
 * @param {Number} minimumFractionDigits
 * @param {Number} maximumFractionDigits
 * @returns {String} the money formatted
 */
function formatMoney(
    value,
    locale,
    currency,
    minimumFractionDigits = 0,
    maximumFractionDigits = 2
) {
    const formatter = new Intl.NumberFormat(locale, {
        currency,
        style: 'currency',
        minimumFractionDigits,
        maximumFractionDigits
    });

    return formatter.format(value);
}

function creatingArrayForNameOptions() {
    arrayOptionNamePersonalization = $.map(
        $('#namePersonalization select.options-select option'),
        function (option) {
            return {
                // We get the id that is stored in the ISML attribute data-value-id
                optionId: option.dataset.valueId,

                // The value attribute contains the URL to request for a option change
                value: option.value,

                // We also get useful prices values, added by customization on data attributes
                price: option.dataset.price,
                priceValue: Number(option.dataset.priceValue)
            };
        }
    );
}

function creatingArrayForNumberOptions() {
    arrayOptionNumberPersonalization = $.map(
        $('#numberPersonalization select.options-select option'),
        function (option) {
            return {
                // We get the id that is stored in the ISML attribute data-value-id
                optionId: option.dataset.valueId,

                // The value attribute contains the URL to request for a option change
                value: option.value,

                // We also get useful prices values, added by customization on data attributes
                price: option.dataset.price,
                priceValue: Number(option.dataset.priceValue)
            };
        }
    );
}

function isValidPersonalizationNumber(number) {
    // Empty string is valid
    return number ? REGEX_NUMBER.test(number) : true;
}

function getSelectOptionsIdsAndValues(selector) {
    /* .options-select is standard class from SFRA.
    We wrap the <select></select> element inside a <div></div>
    which is query by the 'selector' param */
    const options = $(selector).find('select.options-select option');

    return $.map(options, function (option) {
        return {
            // We get the id that is stored in the ISML attribute data-value-id
            optionId: option.dataset.valueId,

            // The value attribute contains the URL to request for a option change
            value: option.value,

            // We also get useful prices values, added by customization on data attributes
            price: option.dataset.price,
            priceValue: Number(option.dataset.priceValue)
        };
    });
}
/*
    Gets the option from the option array matching with the option ID
    In the case of personalizations the ID is the input length, this
    must be reflected in the product options configuration.
*/
function getOptionToChange(optionId, options) {
    return options.find(
        (option) => option.optionId.toString() === optionId.toString()
    );
}
/**
 * Updates the personalization costs elements from the DOM
 * @param {JQuery input} $input - $input from where was triggered the change
 * @param {Object} optionToChange - Option object, the shape is given by getSelectOptionsIdsAndValues
 * @returns {undefined}
 */
function updatePersonalizationCosts($input, optionToChange) {
    /*
        NOTE: For now, we just use the price formattings configurations harcoded
    */
    let newPrice = formatMoney(optionToChange.priceValue, 'es-AR', 'ARS');
    newPrice = removeAllWhiteSpaces(newPrice);
    const $span = $input
        .siblings('div.invalid-feedback')
        .find('span.option-cost-value');

    // Sets the data-price-value attribute of the span
    $span.data('price-value', optionToChange.priceValue);

    // Sets the content text
    $span.text(newPrice);

    let totalPersonalizationPriceValue = 0;
    $('body')
        .find('span.option-cost-value')
        .each(function () {
            totalPersonalizationPriceValue += Number(
                $(this).data('price-value')
            );
        });

    let newTotalPrice = formatMoney(
        totalPersonalizationPriceValue,
        'es-AR',
        'ARS'
    );
    newTotalPrice = removeAllWhiteSpaces(newTotalPrice);

    $('body')
        .find('span.product-personalization-summary-total-cost')
        .text(`+ ${newTotalPrice}`);

    $('body').find('span.finalPrice-personalization').text(`${newTotalPrice}`);
}

/*
    This function simulates the 'change' event on the select element
    which is with display none in the DOM, in this way we can use
    the standard handler function for the 'product option change' event.
    The selector is the custom ID for the div that wraps the select element.
*/
function simulateSelectElementChangeEvent(selector, newValue) {
    $(selector) // Query the div that wraps the <select> element
        .find('select.options-select') // Gets the select element
        .val(newValue);// Updates the option selected with the corresponding value
    // .trigger('change'); // Fires the event 'change' in order to call the corresponding handler.
}
function resetNamePersonalization() {
    var nameOptionValue = arrayOptionNamePersonalization[0] ? arrayOptionNamePersonalization[0].value : 0;
    simulateSelectElementChangeEvent(
        '[data-option-id="namePersonalization"]',
        nameOptionValue
    );
}

function resetNumberPersonalization() {
    var numberOptionValue = arrayOptionNumberPersonalization[0] ? arrayOptionNumberPersonalization[0].value : 0;
    simulateSelectElementChangeEvent(
        '[data-option-id="numberPersonalization"]',
        numberOptionValue
    );
}

/*
    This function simulates the 'input' event
    with empty strings on the personalization inputs
    in this way we can simulate that the inputs were clear
    and then the option "without personalization" was selected
    (for both number and name)
*/
function simulateEmptyInputsEvent() {
    $.spinner().start();
    $('#btn-add-to-cart').prop('disabled', true);
    $('#personalization-form-name').val('').trigger('input');
    $('#personalization-form-number').val('').trigger('input');
    personalization = {};
    resetNamePersonalization();
    setTimeout(() => {
        resetNumberPersonalization();
        $('#btn-add-to-cart').prop('disabled', false);
        $('.btn-get-in-store-inventory').prop('disabled', false);
    }, 1500);
    // changes button text from ADD to EDIT personalization after a new personalization is added
    $('.addNewPersonalization').text('+ Agregar');
    $('.summaryContainer-PDP').addClass('d-none');
    // if PDP details are expanded while personalization is deleted, it return to not expanded state
    $('.titleSummary.-PDP').removeClass('-open');
    resetlocalStoragePersonalization();
    $.spinner().stop();
}

/* handler for the inputs */
function inputHandler(event, inputData, divSelector) {
    event.preventDefault();

    // Deletes the previous timer
    clearTimeout(inputData.timer);

    // Stores the new timer (reset)
    inputData.timer = setTimeout(function () {
        const newInput = event.target.value;
        if (inputData.previousInput === newInput) {
            return;
        }

        /* We store the previous value
        in order to prevent requests in case
        the older value is the same */
        inputData.previousInput = newInput;

        const options = getSelectOptionsIdsAndValues(divSelector);
        const optionToChange = getOptionToChange(newInput.length, options);

        if (optionToChange) {
            // simulateSelectElementChangeEvent(divSelector, optionToChange.value);
            updatePersonalizationCosts($(event.currentTarget), optionToChange);
        }
    }, MS_BEFORE_REQUEST);
}
function personalizationNameConstructor() {
    getEventPersonalizationsModal();
    creatingArrayForNameOptions();
    var lengthFormName = $('#personalization-form-name').val() ? $('#personalization-form-name').val().length : 0;
    var nameValue = arrayOptionNamePersonalization[ lengthFormName ] ? arrayOptionNamePersonalization[ lengthFormName ].value : 0;
    simulateSelectElementChangeEvent(
        '[data-option-id="namePersonalization"]',
        nameValue
    );
}

function personalizationNumberConstructor() {
    getEventPersonalizationsModal();
    creatingArrayForNumberOptions();
    var lengthFormNumber = $('#personalization-form-number').val() ? $('#personalization-form-number').val().length : 0;
    var numberValue = arrayOptionNumberPersonalization[ lengthFormNumber ] ? arrayOptionNumberPersonalization[ lengthFormNumber ].value : 0;
    simulateSelectElementChangeEvent(
        '[data-option-id="numberPersonalization"]',
        numberValue
    );
}

/*
    Sets and unsets the corresponding CSS classes
    from the personalization <input> to remove the errors.
    The case of an empty input is not valid neither invalid.
*/
function clearInputError($input) {
    $input.removeClass('is-invalid');

    if ($input.val()) {
        $input.addClass('border-right-0');
        $input.addClass('is-valid');
    } else {
        $input.removeClass('border-right-0');
        $input.removeClass('is-valid');
    }
}

function initialColorSelectedByDefault() {
    $(document).ready(function () {
        $('.carousel-personalization').each(function () {
            $(this).attr('data-color') === 'negro' ? $(this).addClass('selected-shadow') : '';
        });
    });
}

module.exports = {

    personalizationSKUNumber: function () {
        if ($('#uniqueSize').val() == 1) {
            productID = $('#productSKU').text();
        } else {
            $(document).on('click', '.variation-attribute-size', function () {
                setTimeout(() => {
                    productID = $('#productSKU').text();
                }, 1000);
            });
        }
        if ($('#productSKU').text()) {
            productIDMaster = $('#productSKU').text();
        }
    },

    shwoVariables: function () {
        creatingArrayForNameOptions();
        creatingArrayForNumberOptions();
        resetlocalStoragePersonalization();
    },

    // Initializing Slick Slider to create carousel for colors
    colorCarouselLoad: function () {
        var width = $(document).width();
        var tabletBreak = 820;
        var mobileBreak = 600;

        $(window).on('load', function () {
            initialColorSelectedByDefault();

            if ($('#controlSlider').val() === 'fontON') {
                if (width <= tabletBreak && width > mobileBreak) {
                    $('.slickhere').slick({
                        infinite: true,
                        slidesToShow: 10,
                        slidesToScroll: 5,
                        dots: true
                    });
                } else if (width <= mobileBreak) {
                    $('.slickhere').slick({
                        infinite: true,
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        dots: true
                    });
                } else {
                    $('.slickhere').slick({
                        infinite: true,
                        dots: true,
                        slidesToShow: 10,
                        slidesToScroll: 5
                    });
                }
            } else if (width <= tabletBreak && width > mobileBreak) {
                $('.slickhere').slick({
                    infinite: true,
                    slidesToShow: 10,
                    slidesToScroll: 5,
                    dots: true
                });
            } else if (width <= mobileBreak) {
                $('.slickhere').slick({
                    infinite: true,
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    dots: true
                });
            } else {
                $('.slickhere').slick({
                    infinite: true,
                    dots: true,
                    slidesToShow: 14,
                    slidesToScroll: 5
                });
            }
        });
    },

    selectingPersonalizationColors: function () {
        $('.carousel-personalization').on('click', function () {
            if ($('.carousel-personalization').hasClass('selected-shadow')) {
                $('.carousel-personalization').removeClass('selected-shadow');
                $(this).addClass('selected-shadow');
            } else {
                $(this).addClass('selected-shadow');
            }

            selectedColor = $(this).attr('data-color');
            selectedColorHex = $(this).css('background-color');
            $('.colorNameTitle').text(selectedColor);
            $('.colorSummaryBackground').css('background-color', selectedColorHex);
        });
    },

    personalizationName: function () {
        // We use an object in order to update the objects values inside inputHandler function
        const inputData = {
            timer: null,
            previousInput: ''
        };

        $('#personalization-form-name').on('input', function (e) {
            // First we check that it is a valid value
            personalizationNameHasError = false;
            clearInputError($(this));
            inputHandler(
                e,
                inputData,
                `[data-option-id="${PRODUCT_OPTION_ID_PERSONALIZATION_NAME}"]`
            );
        });
    },
    confirmingPersonalizationOnModalSummary: function () {
        $('.summary-confirm').on('click', function () {
            $.spinner().start();
            getEventPersonalizationsModal();
            personalizationNameConstructor();
            personalizationNumberConstructor();
            setTimeout(() => {
                $.spinner().stop();
            }, 1000);
        });
    },

    personalizationNumber: function () {
        const inputData = {
            timer: null,
            previousInput: ''
        };

        $('#personalization-form-number').on('input', function (e) {
            // Firs we check that it is a valid value
            personalizationNumberHasError = false;
            clearInputError($(this));
            inputHandler(
                e,
                inputData,
                `[data-option-id="${PRODUCT_OPTION_ID_PERSONALIZATION_NUMBER}"]`
            );
        });
    },

    creatingPersonalizationObject: function () {
        $('.personalization-confirm').on(
            'click',
            function addPersonalization() {
                getValuePersonalizationsModal();
                personalization = {
                    numberModal,
                    costNumberModal,
                    nameModal,
                    costNameModal,
                    totalCostModal,
                    nameSide,
                    numberSide,
                    selectedColor,
                    selectedFont
                };
                if (personalization.nameModal === '') {
                    $('#nameSidePersonalizationSummaryList').addClass('d-none');
                } else {
                    $('#nameSidePersonalizationSummaryList').removeClass('d-none');
                    $('.nameSummary').text(personalization.nameModal);
                    $('.namePriceSummary').text(personalization.costNameModal);
                }
                if (personalization.numberModal === '') {
                    $('#numberSidePersonalizationSummaryList').addClass('d-none');
                } else {
                    $('#numberSidePersonalizationSummaryList').removeClass('d-none');
                    $('.numberSummary').text(personalization.numberModal);
                    $('.numberPriceSummary').text(personalization.costNumberModal);
                }
                $('.finalPriceSummary').text(personalization.totalCostModal);
                $('.nameSide').text(personalization.nameSide);
                $('.numberSide').text(personalization.numberSide);
                $('.colorSummary').text(personalization.selectedColor);
                $('.fontSummary').text(personalization.selectedFont);
            }
        );
    },

    changeBetweenPersonalizationAndSummary: function () {
        $('.personalization-confirm').on('click', function () {
            $(
                '.warning-show, .personalizationContainer, .summaryContainer, .main-footer, .summary-footer'
            ).toggleClass('d-none');

            if ($('.personalizationContainer').hasClass('d-none')) {
                $('#mainModal').css('max-width', '600px', 'margin', 'auto');
            } else {
                $('#mainModal').css('max-width', '790px');
            }
        });

        $('.edit-personalization-btn').on('click', function () {
            $(
                '.warning-show, .personalizationContainer, .summaryContainer, .main-footer, .summary-footer'
            ).toggleClass('d-none');

            if ($('.personalizationContainer').hasClass('d-none')) {
                $('#mainModal').css('max-width', '600px', 'margin', 'auto');
            } else {
                $('#mainModal').css('max-width', '790px');
            }
        });
    },

    onlyLettersInputText: function () {
        $('#personalization-form-name').on('input', function () {
            var regexp = /[^a-zA-ZÑñ]/g;
            if ($(this).val().match(regexp)) {
                $('#personalization-form-name').removeClass('is-valid');
                $(this).val($(this).val().replace(regexp, ''));
            }
        });
    },

    onlyNumbersInputNumber: function () {
        var keys = ['+', '-', ',', 'e', 'E', '=', '.'];
        $('#personalization-form-number').on('keypress', function () {
            if ($(this).val().length == 2) return false;
        });

        $('#personalization-form-number').on('keydown', function (e) {
            if (keys.includes(e.key)) return false;
        });
    },

    // prevent user from trying to enter non authorized data by pasting from clipboard
    disableCopyAndPasteForInputs: function () {
        $(document).ready(function () {
            $('.getInput').bind('copy paste cut', function (e) {
                e.preventDefault(); // disable cut,copy,paste
            });
        });
    },

    showAndHideResetButton: function () {
        var nameInput = $('#personalization-form-name')
            .val('')
            .trigger('input');
        var numberInput = $('#personalization-form-number')
            .val('')
            .trigger('input');
        $('.inputs-container input').each(function () {
            // disables the confirmation button based on the inputs given
            $('.inputs-container input').on('input', function () {
                if ($(nameInput).val() !== '' || $(numberInput).val() !== '') {
                    // enabling CONFIRM button
                    $('.personalization-confirm').prop('disabled', false);

                    // refreshing the slider on input event so it renders properly
                    $('.slickhere').slick('refresh');
                    if (hideOptionsArray.includes('Color', 'Fuente')) {
                        $('.text-inputs-personalization').removeClass('d-none');
                    }
                    $(
                        '.reset-separator, .personalization-reset-btn, .colorSlider-container'
                    ).removeClass('d-none');
                } else {
                    $('.reset-separator, .personalization-reset-btn, .colorSlider-container, .text-inputs-personalization').addClass(
                        'd-none'
                    );
                }
            });
        });
    },

    pdpSummaryListEvents: function () {
        // reset button > clears personalization list templates and clears the object containing the personalizations
        $('.personalization-reset-btn, .close-modal-btn').on('click', function () {
            selectedColorHex = '#000';
            selectedColor = 'Negro';

            simulateEmptyInputsEvent();
            initialColorSelectedByDefault();

            // disabling CONFIRM button if the personalization is reseted
            $('.personalization-confirm').prop('disabled', true);

            $('.colorNameTitle').text(selectedColor);
            $('.colorSummaryBackground').css('background-color', selectedColorHex);
            $('.colorSummaryBackground-PDP').css('background-color', selectedColorHex);
            $('.colorSummary, .colorSummary-PDP').text(selectedColor);
            $('.carousel-personalization').removeClass('selected-shadow');
            $('.font-selector option:eq(0)').attr('selected', 'selected');
        });
        // shows personalization details list by confirming modal summary
        $('.summary-confirm').on('click', function () {
            getValuePersonalizationsModal();
            var personalizationPDP = {
                numberModal,
                costNumberModal,
                nameModal,
                costNameModal,
                totalCostModal,
                nameSide,
                numberSide,
                selectedColor,
                selectedFont
            };

            createPersonalizationUniqueID();

            var nameValue = arrayOptionNamePersonalization[0] ? arrayOptionNamePersonalization[0].value : 0;
            var numberValue = arrayOptionNumberPersonalization[0] ? arrayOptionNumberPersonalization[0].value : 0;
            var personalizationsData = window.btoa(JSON.stringify({ personalizationPDP, personalization, nameValue, numberValue }));
            localStorage.setItem(dynamicPersonalization, personalizationsData);
            $('.nameSummary-PDP').text(personalizationPDP.nameModal);
            if (personalizationPDP.nameModal === '') {
                $('#nameSidePersonalizationSummaryList-PDP').addClass('d-none');
            } else {
                $('.nameSummary-PDP').text(personalizationPDP.nameModal);
                $('.namePriceSummary-PDP').text(personalizationPDP.costNameModal);
                $('#nameSidePersonalizationSummaryList-PDP').removeClass('d-none');
            }

            if (personalizationPDP.numberModal === '') {
                $('#numberSidePersonalizationSummaryList-PDP').addClass('d-none');
            } else {
                $('.numberSummary-PDP').text(personalizationPDP.numberModal);
                $('.numberPriceSummary-PDP').text(personalizationPDP.costNumberModal);
                $('#numberSidePersonalizationSummaryList-PDP').removeClass('d-none');
            }
            $('.numberPriceSummary-PDP').text(personalizationPDP.costNumberModal);
            $('.finalPriceSummary-PDP').text(personalizationPDP.totalCostModal);
            $('.colorSummary-PDP').text(personalizationPDP.selectedColor);
            $('.summaryContainer-PDP').removeClass('d-none');
            $('.addNewPersonalization').text('Editar');
            $('.colorSummaryBackground-PDP').css('background-color', selectedColorHex);
            $('.fontSummary-PDP').text(personalizationPDP.selectedFont);
        });
        // shows/hides details by clicking details button
        $('.titleSummary.-PDP').on('click', function () {
            $('.personalizationList.-PDP').toggleClass('d-none');
            $('.titleSummary.-PDP').toggleClass('-open');
        });
        // makes sure that the modal will always open on the page containing inputs
        $('.addNewPersonalization').on('click', function () {
            if ($('.personalizationContainer').hasClass('d-none')) {
                $(
                    '.warning-show, .personalizationContainer, .summaryContainer, .main-footer, .summary-footer'
                ).toggleClass('d-none');
                $('#mainModal').css('max-width', '790px');
            }
        });
    },

    // Adds the input values of product personalization inputs
    // and adds them to the payload that is sent to Cart-AddProduct
    addProductPersonalizationPayloadToAddToCartRequest: function () {
        $('body').on('updateAddToCartFormData', function (e, form) {
            var personatizationsDataGet = {};
            if (localStorage.getItem(pageUUID + '_' + productID + '_personalizationsData')) {
                personatizationsDataGet = JSON.parse(Buffer.from(localStorage.getItem(pageUUID + '_' + productID + '_personalizationsData'), 'base64').toString(
                    'utf-8'
                ));
            }
            var nameModalData = localStorage.getItem(pageUUID + '_' + productID + '_personalizationsData') ? personatizationsDataGet.personalizationPDP.nameModal : '';
            var numberModalData = localStorage.getItem(pageUUID + '_' + productID + '_personalizationsData') ? personatizationsDataGet.personalizationPDP.numberModal : '';

            const name = personalization.name ? personalization.name : nameModalData;
            const number = personalization.number ? personalization.name : numberModalData;
            if ($(name).val() !== '' || $(number).val() !== '') {
                form.productPersonalization = JSON.stringify({
                    name: name || '',
                    number: number || '',
                    personalization: personatizationsDataGet.personalizationPDP || ''
                });
            }
        });
    },

    twinProductPersonalization: function () {
        $('#twinPersonalization').on('change', function () {
            $('#unitedTabs, #twinTabs').toggleClass('d-none');
        });
    },

    clearProductPersonalizationInputs: function () {
        // Same listener as product/base.js colorAttribute
        $(document).on('click', '[data-attr="color"] button', function (e) {
            e.preventDefault();

            if ($(this).attr('disabled')) {
                return;
            }
        });

        // Same listener as product/base.js selectAttribute
        $(document).on(
            'change',
            'select[class*="select-"], .options-select',
            function (e) {
                e.preventDefault();
                // We remove the inputs only if it's a change from a variation attribute
                // if (!$(this).hasClass('options-select')) {
                //     simulateEmptyInputsEvent();
                // }
            }
        );

        // Same listener as app_custom_dabra/.../product/variationAttributeSize.js sizeAttribute
        $(document).on(
            'click',
            'li[class*="variation-attribute-size"], div[class*="variation-attribute-size-values"]',
            function (e) {
                e.preventDefault();
                e.stopPropagation();
                $('.addNewPersonalization').prop('disabled', false);
                $('.summaryContainer-PDP').addClass('d-none');
                $('.addNewPersonalization').text('+ Agregar');
            },
        );
    }
};
// OBSERVER TO TOGGLE PERSONALIZATION BUTTON ENABLED OR DISABLED BASED ON IF THERES ANY PRODUCT SIZE SELECTED
var $elements = $('li[class*="variation-attribute-size"]');

$(window).on('load', function () {
    if ($elements.length < 2 || ($elements).hasClass('selected')) {
        const isAvailableOnlyCC = $('[data-available-only-cc]').data('availableOnlyCc');
        $('.addNewPersonalization').prop('disabled', isAvailableOnlyCC);

        if (!isAvailableOnlyCC) {
            $('.addNewPersonalization').attr('data-target', '#personalization-modal');
        }
    }
});

var callback = function (mutationsList, observer) {
    mutationsList.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            var $isAvailableOnlyCC = $('[data-available-only-cc]').data('availableOnlyCc');
            var $button = $('.addNewPersonalization');
            var $isValidForCustomization = $elements.hasClass('selected') && $isAvailableOnlyCC != true;

            if ($isValidForCustomization) {
                $button.prop('disabled', false);
                $button.attr('data-target', '#personalization-modal');
            } else {
                $button.prop('disabled', true);
                $button.attr('data-target', '');
            }
        }
    });
};

var config = { attributes: true, childList: false, subtree: false };

$elements.each(function () {
    var observer = new MutationObserver(callback);
    observer.observe(this, config);
    if ($elements.hasClass('selected')) return;
});
